module.exports = __webpack_public_path__ + "img/icon-room-bathroom.24527f4d.svg";